import React from 'react'
import HabitTrack from "../Components/Habit_Tracker";
function HabitTracker() {
  return (
    <>
      <HabitTrack/>
    </>
  )
}

export default HabitTracker